export default [
	['basic', [
		{
			"question": "have longer teasing and foreplay sessions with partner",
			"answer": null
		},
		{
			"question": "give {{P}} a sensual massage",
			"answer": null
		},
		{
			"question": "have {{P}} give me a sensual massage",
			"answer": null
		},
		{
			"question": "take pictures of {{P}}",
			"answer": null
		},
		{
			"question": "have pictures taken of me by {{P}}",
			"answer": null
		},
		{
			"question": "take pictures of us having sex",
			"answer": null
		},
		{
			"question": "strip or give a lap dance to {{P}}",
			"answer": null
		},
		{
			"question": "have {{P}} strip or give me a lap dance",
			"answer": null
		},
		{
			"question": "video ourselves having sex",
			"answer": null
		},
		{
			"question": "use mirrors while having sex",
			"answer": null
		},
		{
			"question": "be woken up with sex or oral sex by {{P}}",
			"answer": null
		},
		{
			"question": "wake up {{P}} with sex or oral sex",
			"answer": null
		},
		{
			"question": "watch {{P}} masturbate",
			"answer": null
		},
		{
			"question": "be watched by {{P}} while I masturbate",
			"answer": null
		},
		{
			"question": "shave {{P}}",
			"answer": null
		},
		{
			"question": "be shaven by {{P}}",
			"answer": null
		},
		{
			"question": "shave each other",
			"answer": null
		},
		{
			"question": "watch porn together",
			"answer": null
		},
		{
			"question": "boobjob (thrust penis between breasts)",
			"answer": null
		},
		{
			"question": "be more vocal towards {{P}} during sex",
			"answer": null
		},
		{
			"question": "have {{P}} be more vocal",
			"answer": null
		},
		{
			"question": "talk dirtier to {{P}}",
			"answer": null
		},
		{
			"question": "have {{P}} talk dirtier to me",
			"answer": null
		},
		{
			"question": "have sex while on period",
			"answer": null
		},
		{
			"question": "have sex while on period",
			"answer": null
		},
		{
			"question": "roleplay in costumes",
			"answer": null
		},
		{
			"question": "wear stocking and high heels for {{P}} during sex",
			"answer": null
		},
		{
			"question": "listen to romantic music while having sex",
			"answer": null
		},
		{
			"question": "listen to more aggressive (rap/rock) music while having sex",
			"answer": null
		},
		{
			"question": "mutually masturbate",
			"answer": null
		},
		{
			"question": "be rougher in sex towards {{P}}",
			"answer": null
		},
		{
			"question": "have {{P}} be rougher to me in sex",
			"answer": null
		},
		{
			"question": "be fisted by partner",
			"answer": null
		},
		{
			"question": "69 together",
			"answer": null
		},
		{
			"question": "have {{P}} swallow my cum",
			"answer": null
		},
		{
			"question": "swallow {{P}}'s cum",
			"answer": null
		},
		{
			"question": "cum on breasts/neck (pearl necklace)",
			"answer": null
		},
		{
			"question": "cum on face (facial)",
			"answer": null
		},
		{
			"question": "cum on {{P}}'s face (facial)",
			"answer": null
		},
		{
			"question": "have {{P}} cum over my face (facial)",
			"answer": null
		},
		{
			"question": "have {{P}} sit on my face as I give oral sex",
			"answer": null
		},
		{
			"question": "sit on {{P}}'s face and be given oral sex",
			"answer": null
		},
		{
			"question": "have sex in hot room and have drippy, sweaty sex",
			"answer": null
		},
		{
			"question": "have sex while covered in warm oil",
			"answer": null
		},
		{
			"question": "give oral sex while {{P}} is driving",
			"answer": null
		},
		{
			"question": "receive oral sex while driving",
			"answer": null
		},
		{
			"question": "have partner wear stockings and high heels during sex",
			"answer": null
		},
		{
			"question": "fist {{P}}",
			"answer": null
		},
		{
			"question": "aggressively fuck partners mouth",
			"answer": null
		},
		{
			"question": "have mouth aggressively fucked by partner",
			"answer": null
		},
		{
			"question": "send {{P}} sexy text messages and emails",
			"answer": null
		},
		{
			"question": "receive sexy text messages and emails from {{P}}",
			"answer": null
		},
		{
			"question": "send {{P}} dirty pictures or videos",
			"answer": null
		},
		{
			"question": "receive sexy pictures or videos from {{P}}",
			"answer": null
		},
		{
			"question": "send {{P}} sexy fantasy stories",
			"answer": null
		},
		{
			"question": "receive sexy fantasy stories from {{P}}",
			"answer": null
		},
		{
			"question": "have sex while intoxicated",
			"answer": null
		}
	]],
	['discovery', [
		{
			"question": "show {{P}} something I like from a porn scene",
			"answer": null
		},
		{
			"question": "be shown what {{P}} likes from porn",
			"answer": null
		},
		{
			"question": "Explore {{P}}'s body",
			"answer": null
		},
		{
			"question": "Have {{P}} explore my body",
			"answer": null
		},
		{
			"question": "Show {{P}} the spots and techniques I like on my body",
			"answer": null
		},
		{
			"question": "Have {{P}} show me the spots and techniques they like on their body",
			"answer": null
		}
	]],
	['toys', [
		{
			"question": "use dildos in sex",
			"answer": null
		},
		{
			"question": "use vibrators while having sex",
			"answer": null
		},
		{
			"question": "wear a cock ring (vibrating/non-vibrating) during sex",
			"answer": null
		},
		{
			"question": "use nipple clamps on myself",
			"answer": null
		},
		{
			"question": "use butt plug on myself while having sex",
			"answer": null
		},
		{
			"question": "have {{P}} use a butt plug",
			"answer": null
		},
		{
			"question": "use sex furniture (such as a sex swing or ramp)",
			"answer": null
		},
		{
			"question": "use large dildos during sex",
			"answer": null
		},
		{
			"question": "watch {{P}} fuck a dildo",
			"answer": null
		},
		{
			"question": "fuck dildo while {{P}} watches",
			"answer": null
		},
		{
			"question": "install stripper pole in your house",
			"answer": null
		},
		{
			"question": "have {{P}} use nipple clamps",
			"answer": null
		}
	]],
	['bdsm', [
		{
			"question": "have a weapon (knife, gun) directed at me during sex (knife and gun play)",
			"answer": null
		},
		{
			"question": "direct a weapon (knife, gun) during sex (knife and gun play)",
			"answer": null
		},
		{
			"question": "wear earplugs during sex",
			"answer": null
		},
		{
			"question": "have {{P}} wear earplugs during sex",
			"answer": null
		},
		{
			"question": "slap {{P}}'s face during sex",
			"answer": null
		},
		{
			"question": "have my face slapped during sex",
			"answer": null
		},
		{
			"question": "blindfold {{P}}",
			"answer": null
		},
		{
			"question": "be blindfolded by {{P}}",
			"answer": null
		},
		{
			"question": "punch {{P}} during sex",
			"answer": null
		},
		{
			"question": "be punched by {{P}} during sex",
			"answer": null
		},
		{
			"question": "use restraints on {{P}}",
			"answer": null
		},
		{
			"question": "be tied down or otherwise restrained by {{P}}",
			"answer": null
		},
		{
			"question": "pull {{P}}'s hair",
			"answer": null
		},
		{
			"question": "have my hair pulled by {{P}}",
			"answer": null
		},
		{
			"question": "use a riding crop on {{P}}",
			"answer": null
		},
		{
			"question": "have {{P}} use a riding crop on me",
			"answer": null
		},
		{
			"question": "spank {{P}} with your hand",
			"answer": null
		},
		{
			"question": "be spanked by {{P}}'s hand",
			"answer": null
		},
		{
			"question": "have {{P}} strike me with a cane",
			"answer": null
		},
		{
			"question": "be struck by {{P}} with a cane",
			"answer": null
		},
		{
			"question": "spank {{P}} with toys (whip/paddle)",
			"answer": null
		},
		{
			"question": "be spanked by {{P}} with toys (whip/paddle)",
			"answer": null
		},
		{
			"question": "bite {{P}}",
			"answer": null
		},
		{
			"question": "be bitten by {{P}}",
			"answer": null
		},
		{
			"question": "wear a dog collar with a leash",
			"answer": null
		},
		{
			"question": "have {{P}} wear a dog collar with a leash",
			"answer": null
		},
		{
			"question": "have {{P}} be submissive and worship one of my body parts",
			"answer": null
		},
		{
			"question": "be submissive and worship one of {{P}}'s body parts",
			"answer": null
		},
		{
			"question": "be submissive to {{P}}",
			"answer": null
		},
		{
			"question": "be dominant towards {{P}}",
			"answer": null
		},
		{
			"question": "wear hoods or half hoods for {{P}}",
			"answer": null
		},
		{
			"question": "have {{P}} wear hoods or half-hoods",
			"answer": null
		},
		{
			"question": "have {{P}} act as furniture to be used by me",
			"answer": null
		},
		{
			"question": "act as furniture to be used by {{P}}",
			"answer": null
		},
		{
			"question": "roleplay rape {{P}}",
			"answer": null
		},
		{
			"question": "be roleplay raped by {{P}}",
			"answer": null
		},
		{
			"question": "have {{P}} be a submissive brat",
			"answer": null
		},
		{
			"question": "be a submissive brat towards {{P}}",
			"answer": null
		},
		{
			"question": "have {{P}} be a submissive servant",
			"answer": null
		},
		{
			"question": "be a submissive servant towards {{P}}",
			"answer": null
		},
		{
			"question": "command and deny orgasms for {{P}}",
			"answer": null
		},
		{
			"question": "be commanded and denied orgasms by {{P}}",
			"answer": null
		},
		{
			"question": "be a 24/7 slave for {{P}}",
			"answer": null
		},
		{
			"question": "have {{P}} be a 24/7 slave",
			"answer": null
		},
		{
			"question": "wear a chastity belt for {{P}}",
			"answer": null
		},
		{
			"question": "have {{P}} wear a chastity belt",
			"answer": null
		},
		{
			"question": "be a Gorean slave for {{P}}",
			"answer": null
		},
		{
			"question": "be a Gorean master for {{P}}",
			"answer": null
		},
		{
			"question": "be suspended while having sex with {{P}}",
			"answer": null
		},
		{
			"question": "have {{P}} be suspended while having sex",
			"answer": null
		},
		{
			"question": "wear a ball gag for {{P}}",
			"answer": null
		},
		{
			"question": "have {{P}} wear a ball gag",
			"answer": null
		},
		{
			"question": "torture {{P}}'s genitals",
			"answer": null
		},
		{
			"question": "have {{P}} torture my genitals",
			"answer": null
		},
		{
			"question": "be spanked/whipped lightly",
			"answer": null
		},
		{
			"question": "spank/hit partner lightly",
			"answer": null
		}
	]],
	['anal', [
		{
			"question": "anally fist {{P}}",
			"answer": null
		},
		{
			"question": "be anally fisted by {{P}}",
			"answer": null
		},
		{
			"question": "anally finger {{P}}",
			"answer": null
		},
		{
			"question": "be fingered anally by {{P}}",
			"answer": null
		},
		{
			"question": "anally penetrate {{P}}",
			"answer": null
		},
		{
			"question": "double penetrate partner with me and a toy",
			"answer": null
		},
		{
			"question": "peg partner with a strap-on",
			"answer": null
		},
		{
			"question": "lick {{P}}'s anus (analingus)",
			"answer": null
		},
		{
			"question": "be licked anally by {{P}}",
			"answer": null
		},
		{
			"question": "penetrate {{P}} with a toy while having sex",
			"answer": null
		},
		{
			"question": "be penetrated with a toy while having sex",
			"answer": null
		},
		{
			"question": "be pegged by {{P}}",
			"answer": null
		},
		{
			"question": "wear a buttplug in public",
			"answer": null
		},
		{
			"question": "have {{P}} wear a buttplug in public",
			"answer": null
		},
		{
			"question": "be anally penetrated by {{P}}",
			"answer": null
		}
	]],
	['public', [
		{
			"question": "fondle {{P}} in a public setting (restaurant/theater)",
			"answer": null
		},
		{
			"question": "be fondled by {{P}} in a public setting (restaurant/theater)",
			"answer": null
		},
		{
			"question": "have my pictures posted on the internet",
			"answer": null
		},
		{
			"question": "show pictures of us having sex over the internet",
			"answer": null
		},
		{
			"question": "show pictures/film of {{P}} over the internet",
			"answer": null
		},
		{
			"question": "have sex in a car",
			"answer": null
		},
		{
			"question": "have sex in the woods or in a park",
			"answer": null
		},
		{
			"question": "have sex in work environment (office, etc)",
			"answer": null
		},
		{
			"question": "have sex in front of an outward facing window",
			"answer": null
		},
		{
			"question": "have sex in a place where you might get caught",
			"answer": null
		},
		{
			"question": "watch {{P}} have sex with another person",
			"answer": null
		},
		{
			"question": "have sex with another person while {{P}} watches",
			"answer": null
		},
		{
			"question": "go to a strip club with partner",
			"answer": null
		},
		{
			"question": "go to a sex or swingers club with partner",
			"answer": null
		},
		{
			"question": "go to a nudist resort with partner",
			"answer": null
		},
		{
			"question": "go to a pleasure resort with partner",
			"answer": null
		},
		{
			"question": "start a social media account (i.e. instagram, tumblr, reddit) and post sexy videos and pictures",
			"answer": null
		},
		{
			"question": "wear a vibrator with wireless remote that {{P}} controls in public",
			"answer": null
		},
		{
			"question": "have partner wear a vibrator with a wireless remote that you control in public",
			"answer": null
		},
		{
			"question": "use sex toys in public (i.e. vibrator up skirt at a restaurant or while out shopping)",
			"answer": null
		},
		{
			"question": "take sexy photos in secluded places (i.e. dirt road, park, parking garage)",
			"answer": null
		},
		{
			"question": "strip at a sex club in front of partner",
			"answer": null
		},
		{
			"question": "watch {{P}} strip at a sex club",
			"answer": null
		},
		{
			"question": "strip at amateur night at a strip club",
			"answer": null
		},
		{
			"question": "watch {{P}} strip at amateur night at a strip club",
			"answer": null
		},
		{
			"question": "give lap dance to {{P}}",
			"answer": null
		},
		{
			"question": "get lap dance from {{P}}",
			"answer": null
		},
		{
			"question": "perform oral sex on {{P}} in a public setting",
			"answer": null
		},
		{
			"question": "have oral sex performed on you by {{P}} in a public setting",
			"answer": null
		},
		{
			"question": "have sex in a movie theater",
			"answer": null
		},
		{
			"question": "have sex on the beach",
			"answer": null
		},
		{
			"question": "be gangbanged while {{P}} watches",
			"answer": null
		},
		{
			"question": "watch {{P}} get gangbanged",
			"answer": null
		},
		{
			"question": "participate while {{P}} gets gangbanged",
			"answer": null
		},
		{
			"question": "be gangbanged while {{P}} participates",
			"answer": null
		},
		{
			"question": "go to nude beach with partner",
			"answer": null
		},
		{
			"question": "go to a sex club or resort with partner",
			"answer": null
		},
		{
			"question": "wear thong bikini in public",
			"answer": null
		},
		{
			"question": "have {{P}} wear thong bikini in public",
			"answer": null
		},
		{
			"question": "wear only long coat in public with nothing underneath",
			"answer": null
		},
		{
			"question": "have {{P}} only wear long coat in public with nothing underneath",
			"answer": null
		},
		{
			"question": "go commando in public",
			"answer": null
		},
		{
			"question": "Take sexy or nude photos in public places (i.e. upskirt pictures, flashing, bending over)",
			"answer": null
		},
		{
			"question": "wear sexy lingerie under clothing in public",
			"answer": null
		},
		{
			"question": "have {{P}} wear sexy lingerie under clothing in public",
			"answer": null
		},
		{
			"question": "wear latex, leather, lace or other sensual materials in public",
			"answer": null
		},
		{
			"question": "have {{P}} wear latex, leather, lace or other sensual materials in public",
			"answer": null
		}
	]],
	['group', [
		{
			"question": "be bukkake'd by partner and other males",
			"answer": null
		},
		{
			"question": "double penetration by your partner and another man",
			"answer": null
		},
		{
			"question": "triple penetration by your partner two other males",
			"answer": null
		},
		{
			"question": "watch other couples have sex (live)",
			"answer": null
		},
		{
			"question": "let another couple watch us have sex",
			"answer": null
		},
		{
			"question": "have sex monogamously with other couples (don't touch other couples)",
			"answer": null
		},
		{
			"question": "include another female in sex",
			"answer": null
		},
		{
			"question": "include another male in sex",
			"answer": null
		},
		{
			"question": "include another couple in sex (swinging, soft-swap, no penetration outside couples)",
			"answer": null
		},
		{
			"question": "include more than two males in sex",
			"answer": null
		},
		{
			"question": "include more than two females in sex",
			"answer": null
		},
		{
			"question": "participate in an large orgy (more than 4 people)",
			"answer": null
		},
		{
			"question": "suck semen out of partner's vagina or anus after sex (felching)",
			"answer": null
		},
		{
			"question": "double penetrate partner with another man",
			"answer": null
		},
		{
			"question": "triple penetrate partner with two other men",
			"answer": null
		},
		{
			"question": "include another couple in sex (swinging, full-swap)",
			"answer": null
		},
		{
			"question": "have another person take video/photos while we have sex",
			"answer": null
		},
		{
			"question": "let a group of people watch us have sex",
			"answer": null
		},
		{
			"question": "let a female friend watch us have sex",
			"answer": null
		},
		{
			"question": "let a male friend watch us have sex",
			"answer": null
		},
		{
			"question": "include another female in sex where only the females interact (FFM)",
			"answer": null
		},
		{
			"question": "include another male in sex where only the males interact (MMF)",
			"answer": null
		}
	]],
	['other', [
		{
			"question": "call {{P}} obscene words (bitch, slut, whore, etc)",
			"answer": null
		},
		{
			"question": "be called obscene words (bitch, slut, whore, etc) by {{P}}",
			"answer": null
		},
		{
			"question": "give {{P}} a foot job",
			"answer": null
		},
		{
			"question": "be given a foot job",
			"answer": null
		},
		{
			"question": "douse ourselves in oil/mud/paint/milk/pies during sex",
			"answer": null
		},
		{
			"question": "use chemicals (menthol, toothpaste, ben-gay) on {{P}}",
			"answer": null
		},
		{
			"question": "have partner use chemicals on me (menthol, toothpaste, ben-gay)",
			"answer": null
		},
		{
			"question": "have {{P}} give me a golden shower",
			"answer": null
		},
		{
			"question": "give {{P}} a golden shower",
			"answer": null
		},
		{
			"question": "have {{P}} give me a brown shower",
			"answer": null
		},
		{
			"question": "give {{P}} a brown shower",
			"answer": null
		},
		{
			"question": "swap my cum with my partner",
			"answer": null
		},
		{
			"question": "suck semen out of partner's vagina or anus after sex (felching)",
			"answer": null
		},
		{
			"question": "wear latex catsuit during sex",
			"answer": null
		},
		{
			"question": "have partner wear latex catsuit during sex",
			"answer": null
		},
		{
			"question": "get lap dance while {{P}} watches",
			"answer": null
		},
		{
			"question": "watch {{P}} get a lap dance",
			"answer": null
		},
		{
			"question": "watch {{P}} give lap dance to someone else",
			"answer": null
		},
		{
			"question": "give lap dance to someone else while {{P}} watches",
			"answer": null
		},
		{
			"question": "flash someone else in front of {{P}}",
			"answer": null
		},
		{
			"question": "watch {{P}} flash someone else",
			"answer": null
		},
		{
			"question": "flirt with others in front of {{P}}",
			"answer": null
		},
		{
			"question": "watch {{P}} flirt with others",
			"answer": null
		},
		{
			"question": "dance with someone else while {{P}} watches",
			"answer": null
		},
		{
			"question": "watch {{P}} dance with someone else",
			"answer": null
		},
		{
			"question": "fondle someone else while {{P}} watches",
			"answer": null
		},
		{
			"question": "watch {{P}} fondle someone else",
			"answer": null
		},
		{
			"question": "perform oral sex on someone else in front of {{P}}",
			"answer": null
		},
		{
			"question": "have oral sex performed on you by someone else while {{P}} watches",
			"answer": null
		},
		{
			"question": "watch {{P}} get fondled by someone else",
			"answer": null
		},
		{
			"question": "be fondled by someone else while {{P}} watches",
			"answer": null
		},
		{
			"question": "grind on someone else while {{P}} watches",
			"answer": null
		},
		{
			"question": "watch partner grind on someone else",
			"answer": null
		},
		{
			"question": "dress sexy and meet partner at bar or club to roleplay as strangers",
			"answer": null
		},
		{
			"question": "watch partner perform oral sex on someone else",
			"answer": null
		},
		{
			"question": "watch partner have oral sex performed on him/her by someone else",
			"answer": null
		}
	]]
];


// WEBPACK FOOTER //
// ./src/lib/advancedQuestions.ts